import { useParams } from "react-router-dom";
import Page from "../../components/Page";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { url } from "../../url";
import { useEffect, useState } from "react";
import styles from "./ProjectDetail.module.scss";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import FavoriteIcon from "@mui/icons-material/Favorite";
import ChatIcon from "@mui/icons-material/Chat";
import { useAtom } from "jotai";
import { userProjectsAtom } from "../Projects/atoms/UserProjectAtomGlobal";
import { chosenUserAtom } from "../Conversations/atoms/ChatAtom";
import Alert from "@mui/material/Alert";
import { Check } from "@mui/icons-material";
import { socket } from "../../socket/socket";
import React from "react";
import { FILTERS } from '../../filters/filtersConfig';

const getData = async (id: string) => {
  const response = await axios.get(url + `/project/${id}`, {
    headers: { "Content-Type": "application/json" },
  });
  return response.data;
};

const getSavedData = async (token: string) => {
  const response = await axios.get(url + "/user/projects/found", {
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
  });
  return response.data;
};

const getUserData = async (token: string) => {
  const response = await axios.get(url + "/user/myProjectsIds", {
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
  });
  return response.data;
};

const ProjectDetail = () => {
  const [data, setData] = useState<any>(null);
  const [projectCreator, setProjectCreator] = useState<any>({});
  const [mouseHeartEnter, setMouseHeartEnter] = useState<boolean>(false);
  const [mouseChatEnter, setMouseChatEnter] = useState<boolean>(false);
  const [projectsAdded, setProjectsAdded] = useState<any>({});
  const [userProjects, setUserProjects] = useAtom(userProjectsAtom);
  const [userCreatedProjectsIds, setUserCreatedProjectsIds] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [message, setMessage] = useState<string>("");
  const { id } = useParams();
  const navigate = useNavigate();
  const [chosenUser, setChosenUser] = useAtom(chosenUserAtom);
  const [showAlert, setShowAlert] = useState<boolean>(false);

  const addUserProject = async (project: any): Promise<void> => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        await axios.post(
          url + `/user/projects/${project._id}`,
          {},
          { headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` } }
        );
        setUserProjects([...userProjects, project._id]);
      } catch (err) {
        console.log(err);
      }
    }
    setProjectsAdded((prevState: any) => ({ ...prevState, [project._id]: true }));
  };

  const onChangeTextArea = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setMessage(event.target.value);
  };

  const onClickSendMessageButtonClick = async () => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const response = await axios.post(
          url + `/chat/singlePage/sendMessage`,
          { id: projectCreator._id, message: message },
          { headers: { Authorization: `Bearer ${token}` } }
        );
        const data = response.data;
        socket.emit("join", data.message.conversationId);
        socket.emit("chat", { room: data.message.conversationId, user: projectCreator._id, text: message });
        socket.off("join");
        socket.off("chat");
        setShowAlert(true);
        setTimeout(() => setShowAlert(false), 3500);
        setMessage("");
        return;
      } catch (err) {
        if (err) {
          return alert("???");
        }
      }
    }
    return alert("You need to be logged lol");
  };

  const deleteUserProject = async (project: any): Promise<void> => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        await axios.delete(url + `/user/projects/${project._id}`, {
          headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        });
        setUserProjects(userProjects.filter((p: any) => p !== project._id));
      } catch (err) {
        console.log(err);
      }
    }
    setProjectsAdded((prevState: any) => ({ ...prevState, [project._id]: false }));
  };

  const redirectToConversation = (projectCreator: any) => {
    if (localStorage.getItem("token")) {
      setChosenUser(projectCreator);
      navigate("/conversations");
    } else {
      navigate("/login");
    }
  };

  const handleHeartClick = () => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login");
      return;
    }
    
    !userProjects?.includes(data._id)
      ? addUserProject(data)
      : deleteUserProject(data);
  };

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      if (id) {
        const response = await getData(id);
        setData(response.project);
        setProjectCreator(response.project_creator);
        setLoading(false);
      }
    };
    fetchData();
  }, [id]);

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("token");
      if (token) {
        const response = await getUserData(token);
        setUserCreatedProjectsIds(response.myProjectsIds);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("token");
      if (token) {
        const response = await getSavedData(token);
        setUserProjects(response.projects);
      }
    };
    fetchData();
  }, []);

  if (loading) {
    return <Page><div>Loading...</div></Page>;
  }

  if (!data) {
    return <Page><div>Project not found.</div></Page>;
  }

  return (
    <Page>
      <div className={styles.pageWrapper}>
        <main className={styles.mainContent}>
          {/* Header */}
          <header className={styles.header}>
            <div className={styles.titleWrapper}>
              <h1 className={styles.projectName}>{data.projectName}</h1>
              <div className={styles.ownerInfo}>
                Owner: <a href="#" className={styles.ownerLink}>{projectCreator.username}</a>
              </div>
              {userCreatedProjectsIds?.includes(data._id) && (
                <button
                  className={"" + styles.editButton}
                  style={{ float: 'right', marginLeft: 'auto' }}
                  onClick={() => navigate(`/project/editProject/${data._id}`)}
                >
                  Edit Profile
                </button>
              )}
            </div>
            {!userCreatedProjectsIds?.includes(data._id) && (
              <div className={styles.actions}>
                <button className={styles.iconButton} onClick={handleHeartClick}>
                  {userProjects?.includes(data._id) ? <FavoriteIcon /> : <FavoriteBorderIcon />}
                </button>
                <button className={styles.iconButton} onClick={() => redirectToConversation(projectCreator)}>
                  <ChatIcon />
                </button>
              </div>
            )}
          </header>

          {/* Description and Goal */}
          <section className={styles.descriptionSection}>
            <p>{data.description}</p>
            {data.projectGoal && (
              <div className={styles.projectGoal}>
                <strong>Project Goal:</strong> {data.projectGoal}
              </div>
            )}
          </section>

          {/* Details Grid */}
          <section className={styles.detailsGrid}>
            {/* Core Project Details */}
            {data.deadlineTo && (
              <div className={styles.detailItem}>
                <strong className={styles.detailLabel}>Deadline:</strong>
                <span className={styles.detailValue}>
                  {data.deadlineFrom ? `${new Date(data.deadlineFrom).toLocaleDateString()} - ` : ""}
                  {new Date(data.deadlineTo).toLocaleDateString()}
                </span>
              </div>
            )}
            {typeof data.availability === "number" && (
              <div className={styles.detailItem}>
                <strong className={styles.detailLabel}>{FILTERS.requiredAvailability.label}:</strong>
                <span className={styles.detailValue}>
                  {`${data.availability} hours per week`}
                </span>
              </div>
            )}
            {data.baseLocation && data.baseLocation.length > 0 && (
              <div className={styles.detailItem}>
                <strong className={styles.detailLabel}>Location:</strong>
                <span className={styles.detailValue}>{data.baseLocation.join(", ")}</span>
              </div>
            )}
            {data.weeklyEngagement && (
              <div className={styles.detailItem}>
                <strong className={styles.detailLabel}>Weekly Engagement:</strong>
                <span
                  className={styles.detailValue}
                >{`${data.weeklyEngagement.from} - ${data.weeklyEngagement.to} hours`}</span>
              </div>
            )}
            {(data.workingTypeOffice || data.workingTypeRemote) && (
              <div className={styles.detailItem}>
                <strong className={styles.detailLabel}>Working Type:</strong>
                <div className={styles.tagGroup}>
                  {data.workingTypeOffice && <span className={styles.tag}>Office</span>}
                  {data.workingTypeRemote && <span className={styles.tag}>Remote</span>}
                </div>
              </div>
            )}
            {(data.bizPosition || data.techPosition) && (
              <div className={styles.detailItem}>
                <strong className={styles.detailLabel}>Role Distribution:</strong>
                <span
                  className={styles.detailValue}
                >{`Business: ${data.bizPosition || 0}% / Tech: ${data.techPosition || 0}%`}</span>
              </div>
            )}

            {/* Project Classification */}
            {data.projectType && data.projectType.length > 0 && (
              <div className={styles.detailItem}>
                <strong className={styles.detailLabel}>{FILTERS.projectType.label}:</strong>
                <div className={styles.tagGroup}>
                  {Array.isArray(data.projectType) ? 
                    data.projectType.map((item: string, index: number) => (
                      <span key={index} className={styles.tag}>
                        {item}
                      </span>
                    )) : 
                    <span className={styles.tag}>{data.projectType}</span>
                  }
                </div>
              </div>
            )}
            {data.productType && data.productType.length > 0 && (
              <div className={styles.detailItem}>
                <strong className={styles.detailLabel}>{FILTERS.productType ? FILTERS.productType.label : 'Product Type'}:</strong>
                <div className={styles.tagGroup}>
                  {data.productType.map((item: string, index: number) => (
                    <span key={index} className={styles.tag}>
                      {item}
                    </span>
                  ))}
                </div>
              </div>
            )}
            {data.areaOfExpertise && data.areaOfExpertise.length > 0 && (
              <div className={styles.detailItem}>
                <strong className={styles.detailLabel}>Area of Expertise:</strong>
                <div className={styles.tagGroup}>
                  {data.areaOfExpertise.map((item: string, index: number) => (
                    <span key={index} className={styles.tag}>
                      {item}
                    </span>
                  ))}
                </div>
              </div>
            )}
            {data.sectorDetails && data.sectorDetails.length > 0 && (
              <div className={styles.detailItem}>
                <strong className={styles.detailLabel}>Sector Details:</strong>
                <div className={styles.tagGroup}>
                  {data.sectorDetails.map((item: string, index: number) => (
                    <span key={index} className={styles.tag}>
                      {item}
                    </span>
                  ))}
                </div>
              </div>
            )}

            {/* Compensation */}
            {data.offeredGratification && data.offeredGratification.length > 0 && (
              <div className={styles.detailItem}>
                <strong className={styles.detailLabel}>{FILTERS.offeredGratification.label}:</strong>
                <div className={styles.tagGroup}>
                  {data.offeredGratification.map((item: string, index: number) => (
                    <span key={index} className={styles.tag}>
                      {item}
                    </span>
                  ))}
                </div>
              </div>
            )}
            {data.forGratification && data.forGratification.length > 0 && (
              <div className={styles.detailItem}>
                <strong className={styles.detailLabel}>{FILTERS.forGratification.label}:</strong>
                <div className={styles.tagGroup}>
                  {data.forGratification.map((item: string, index: number) => (
                    <span key={index} className={styles.tag}>
                      {item}
                    </span>
                  ))}
                </div>
              </div>
            )}

            {/* Required Skills & Assets */}
            {data.softSkills && data.softSkills.length > 0 && (
              <div className={styles.detailItem}>
                <strong className={styles.detailLabel}>Soft Skills:</strong>
                <div className={styles.tagGroup}>
                  {data.softSkills.map((item: string, index: number) => (
                    <span key={index} className={styles.tag}>
                      {item}
                    </span>
                  ))}
                </div>
              </div>
            )}
            {data.personalAssets && data.personalAssets.length > 0 && (
              <div className={styles.detailItem}>
                <strong className={styles.detailLabel}>Personal Assets:</strong>
                <div className={styles.tagGroup}>
                  {data.personalAssets.map((item: string, index: number) => (
                    <span key={index} className={styles.tag}>
                      {item}
                    </span>
                  ))}
                </div>
              </div>
            )}
            {data.speakingLanguagesRequired && data.speakingLanguagesRequired.length > 0 && (
              <div className={styles.detailItem}>
                <strong className={styles.detailLabel}>Required Languages:</strong>
                <div className={styles.tagGroup}>
                  {data.speakingLanguagesRequired.map((item: string, index: number) => (
                    <span key={index} className={styles.tag}>
                      {item}
                    </span>
                  ))}
                </div>
              </div>
            )}
            {data.toolsExperience && data.toolsExperience.length > 0 && (
              <div className={styles.detailItemFull}>
                <strong className={styles.detailLabel}>{FILTERS.toolsExperience.label}:</strong>
                <div className={styles.tagGroup}>
                  {data.toolsExperience.map((item: any, index: number) => (
                    <span key={index} className={styles.tag}>{item.tool}</span>
                  ))}
                </div>
              </div>
            )}
          </section>
        </main>

        {/* Right Pane */}
        {!userCreatedProjectsIds?.includes(data._id) && (
          <aside className={styles.rightPane}>
            <div className={styles.messageCard}>
              <h3 className={styles.messageTitle}>Send a message to project creator!</h3>
              <textarea
                className={styles.messageInput}
                placeholder="Write your message..."
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              ></textarea>
              <button className={styles.sendMessageButton} onClick={onClickSendMessageButtonClick}>
                Send a message
              </button>
              {showAlert && (
                <Alert
                  className={styles.sendMessage_alert}
                  icon={<Check fontSize="inherit" />}
                  severity="success"
                >
                  You have sent a message!
                </Alert>
              )}
            </div>
          </aside>
        )}
      </div>
    </Page>
  );
};

export default ProjectDetail;